



























































































import Vue from "vue";
import Component from "vue-class-component";
import constants from "../../config/constants";
import rules from "../../utils/rules";

@Component
export default class ContactForm extends Vue {
  emailRules = [rules.email];
  generalRules = [rules.notEmpty];
  contact = {
    email: "",
    firstName: "",
    lastName: "",
    description: "",
  };
  valid = false;
  loading = false;
  snackbarSuccess = false;
  snackbarError = false;

  $refs!: {
    form: HTMLFormElement;
  };
  async onSubmit() {
    this.loading = true;
    try {
      await this.$store.dispatch("contact/createContact", {
        ...this.contact,
        type: constants.CONTACT_TYPE.CONTACT_US,
      });
      this.$refs.form.reset();
      this.snackbarSuccess = true;
    } catch {
      this.snackbarError = true;
    }
    this.loading = false;
  }
}
